import React, { useState, useEffect } from "react";
import { Form, Switch, Checkbox, Row, Col, Radio, Modal } from "antd";
import { connect } from "react-redux";
import {
  setBreakTypesList,
  setLeaveCategoryList,
  setRoleList,
} from "redux/actions";
import {
  getLocations,
  getClientid,
  getAllDepartmentList,
} from "redux/selectors";
import { bindActionCreators } from "redux";
import { CALL_API } from "common/API";
import { STATUS_CODE, VALIDATE_CHARACTER } from "common/Constants";
import GridBuilder from "UIBuilderEngine/GridBuilder";
import EditSelectTable from "molecules/EditSelectTable";
import TabsList from "molecules/TabsList";
import { getEditLeaveJson } from "JsonFormat/EditLeaveJson";
import FormModal from "./FormModal";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { ButtonOutlined } from "reusableComponent/UIButtons";
import AlertModal from "./AlertModal";
import moment from "moment";

const EditLeaves = ({
  isModalVisible,
  closeModal,
  ClientId,
  getLeaveList,
  LeaveDetails,
  saveLeaveCategoryList,
  departmentList,
  locationList,
  viewOnly,
  saveRoleList,
  LeaveList,
}) => {
  console.log("LeaveDetails", LeaveDetails);
  const [form] = Form.useForm();
  const [showPopup, setShowPopup] = useState(false);
  const [publishOpen, setPublishOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [initialData, setInitialData] = useState({});

  useEffect(() => {
    const values = {
      ...LeaveDetails,

      accrual: LeaveDetails?.accrual,
      accrualtype: LeaveDetails?.accrualtype,
      rollout: LeaveDetails?.rollout,
       reliever: LeaveDetails?.reliever,
      expiry_date: LeaveDetails?.expiry_date
        ? moment(LeaveDetails?.expiry_date, "YYYY-MM-DD")
        : null,
    };
    setInitialData(values);
  }, [LeaveDetails]);

  const filterLocationList = locationList?.filter(
    (item) => item?.login_from_anywhere !== 1
  );

  const fetchMasterData = async (fetch_master_data) => {
    const { code, leaveCategories, roleList } = await CALL_API(
      `master-data/${ClientId}`,
      "post",
      {
        fetch_master_data,
      }
    );
    if (code === STATUS_CODE.SUCCESS) {
      saveLeaveCategoryList(leaveCategories);
      saveRoleList(roleList);
    }
  };

  const [data, setData] = useState({});
  useEffect(() => {
    setData({
      leaveCategoryId: LeaveDetails.leaveCategoryId,
      leaveCategoryName: LeaveDetails.leaveCategoryName,
      numberOfLeaves: LeaveDetails.numberOfLeaves,
      eligible: LeaveDetails.eligible,
      holiday: LeaveDetails?.holiday,
      weekend: LeaveDetails?.weekend,
      isSaturday: LeaveDetails?.isSaturday,
      accumulated: LeaveDetails?.accumulated,
      expiry_date: LeaveDetails?.expiry_date
        ? moment(LeaveDetails.expiry_date, "MMMM").add(1, "year").endOf("month")
        : null,
      accrualtype: LeaveDetails?.accrualtype,
      accrual: LeaveDetails?.accrual,
      rollout: LeaveDetails?.rollout,
      reliever: LeaveDetails?.reliever,
    });
  }, [LeaveDetails]);

  const { EditLeaveForm } = getEditLeaveJson(data, LeaveList);
  const [submit, setsubmit] = useState(false);
  const [selectDepartmentId, setSelectDepartmentId] = useState([]);
  const [selectedLocationId, setSelectedLocationId] = useState([]);
  const [openDepartmentModal, setOpenDepartmentModal] = useState(false);
  const [openLocationModal, setOpenLocationModal] = useState(false);
  const [selectAllDepartmentsChecked, setSelectAllDepartmentsChecked] =
    useState(false);
  const [selectAllLocationChecked, setSelectAllLocationChecked] =
    useState(false);
  useEffect(() => {
    form.setFieldsValue({
      leave_category_name: LeaveDetails.leaveCategoryName,
      numberofLeaves: LeaveDetails.numberOfLeaves,
      description: LeaveDetails.description,
      holidays: LeaveDetails?.holiday,
      weekend: LeaveDetails?.weekend,
    });
    setSelectedLocationId(LeaveDetails.locationId);
    setSelectDepartmentId(LeaveDetails.departmentId);
  }, [LeaveDetails]);

  useEffect(() => {
    setSelectAllDepartmentsChecked(
      selectDepartmentId?.length === departmentList?.length
    );
    setSelectAllLocationChecked(
      selectedLocationId?.length === filterLocationList?.length
    );
  }, [selectDepartmentId, departmentList, selectedLocationId, locationList]);

  const handleFormChange = (e) => {
    console.log("event", e);
    if (e.target.name === "accrual") {
      setShowPopup(true);
    }
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
    setsubmit(true);
  };

  const departmentcolumns = [
    {
      title: "Department Name",
      dataIndex: "department_name",
      key: "department_name",
      width: "10%",
    },
    {
      title: "Access Level",
      dataIndex: "department_id",
      key: "department_id",
      width: "10%",
      align: "center",
      render: (department_id) => {
        const check = selectDepartmentId?.includes(department_id)
          ? true
          : false;
        return (
          <Switch
            disabled={viewOnly}
            checked={check}
            size="small"
            onChange={(checked) => getDepartmentId(department_id, checked)}
          />
        );
      },
    },
  ];

  const getDepartmentId = (department_id, checked) => {
    const newDepartmentId = checked
      ? [...selectDepartmentId, department_id]
      : selectDepartmentId.filter((item) => item !== department_id);
    setSelectDepartmentId(newDepartmentId);
    setsubmit(true);
  };

  const handleSelectAllDepartmentsChange = (e) => {
    const checked = e.target.checked;
    setSelectAllDepartmentsChecked(checked);
    const allDepartmentIds = departmentList.map((item) => item.department_id);
    setSelectDepartmentId(checked ? allDepartmentIds : []);
    setsubmit(true);
  };

  const locatincolumns = [
    {
      title: "Location Name",
      dataIndex: "location_name",
      key: "location_name",
      width: "10%",
    },
    {
      title: "Access Level",
      dataIndex: "location_id",
      key: "location_id",
      width: "10%",
      align: "center",
      render: (location_id, record) => {
        const check = selectedLocationId?.includes(location_id) ? true : false;
        return (
          <Switch
            disabled={viewOnly}
            size="small"
            checked={check}
            onChange={(checked) => getLocationId(location_id, checked)}
          />
        );
      },
    },
  ];

  const getLocationId = (location_id, checked) => {
    const newLocationId = checked
      ? [...selectedLocationId, location_id]
      : selectedLocationId.filter((item) => item !== location_id);
    setSelectedLocationId(newLocationId);
    setsubmit(true);
  };

  const handleSelectAllLocationChange = (e) => {
    const checked = e.target.checked;
    setSelectAllLocationChecked(checked);
    const allDepaetmentIds = filterLocationList.map((item) => item.location_id);
    setSelectedLocationId(checked ? allDepaetmentIds : []);
    setsubmit(true);
  };

  useEffect(() => {
    if (submit) {
      onFinish();
    }
  }, [selectDepartmentId, selectedLocationId, data]);

  const onFinish = async (isPublish = false) => {
    setLoading(true);
    const {
      leaveCategoryId,
      leaveCategoryName,
      numberOfLeaves,
      eligible,
      holiday,
      weekend,
      isSaturday,
       reliever
    } = data;
    console.log("data", data);
    const containsSpecialCharacters =
      !VALIDATE_CHARACTER.test(leaveCategoryName);
    if (containsSpecialCharacters) {
      return;
    }
    const { code } = await CALL_API(
      `owner-leave/${ClientId}/${leaveCategoryId}`,
      "patch",
      {
        leavecategoryname: leaveCategoryName,
        numberofleaves: numberOfLeaves,
        department: selectDepartmentId,
        location: selectedLocationId,
        eligible: eligible,
        holiday: holiday ? holiday : "No",
        weekend: weekend ? weekend : "No",
        publishedstatus: isPublish ? isPublish : false,
        isSaturday: isSaturday ? isSaturday : "No",
        accumulated: data?.accumulated,
        reliever: reliever,
        // expiry_date: moment(expiry_date).format("MMMM YYYY") ?? null,
        expiry_date: data?.expiry_date
          ? moment(data?.expiry_date)
              .endOf("month")
              .format("MMMM")
              .charAt(0)
              .toUpperCase() +
            moment(data?.expiry_date)
              .endOf("month")
              .format("MMMM")
              .slice(1)
              .toLowerCase()
          : moment()
              .add(1, "year")
              .endOf("year")
              .format("MMMM")
              .charAt(0)
              .toUpperCase() +
            moment()
              .add(1, "year")
              .endOf("year")
              .format("MMMM")
              .slice(1)
              .toLowerCase(),
        accrual: data?.accrual,
        rollout: data?.rollout,
        accrualtype: data?.accrual === "No" ? "Yearly" : data?.accrualtype,
      }
    );
    if (code === STATUS_CODE.SUCCESS) {
      fetchMasterData();
      getLeaveList();
    }
    setLoading(false);
    setPublishOpen(false);
  };

  const items = [
    {
      id: 1,
      label: "Basic",
      component: (
        <>
          {viewOnly ? (
            <>
              <div className="styled-card">
                <Row className="mb-3">
                  <Col>
                    <b>Leave Category Name</b> : {data.leaveCategoryName}
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col>
                    <b>Number of Leaves</b> : {data.numberOfLeaves}
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col>
                    <b>Eligible</b> : {data.eligible}
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col>
                    <b>Include Saturdays</b> : {data?.isSaturday}
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col>
                    <b>Include Sundays</b> : {data?.weekend}
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col>
                    <b>Include Holidays</b> : {data?.holiday}
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col>
                    <b>Accrual</b> : {data?.accrual || "-"}
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col>
                    <b>Accrual Type</b> : {data?.accrualtype || "-"}
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col>
                    <b>Do you want to roll out this leave to next year ?</b> :{" "}
                    {data?.rollout || "-"}
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col>
                    <b>Expiry Date</b> :{" "}
                    {moment(data?.expiry_date)?.isValid() &&
                    data?.rollout === "Yes"
                      ? moment(data?.expiry_date)?.format("DD, MMMM")
                      : "-"}
                  </Col>
                </Row>
              </div>
            </>
          ) : (
            <div className="styled-card">
              <GridBuilder
                formStructureJson={EditLeaveForm}
                handleChange={handleFormChange}
                initialValues={initialData}
              />
            </div>
          )}
        </>
      ),
    },
    {
      id: 2,
      label: "Department",
      component: (
        <>
          {!viewOnly && (
            <div className="mb-3 d-flex justify-content-between">
              {departmentList?.length > 0 && (
                <Checkbox
                  className=""
                  checked={selectAllDepartmentsChecked}
                  onChange={handleSelectAllDepartmentsChange}
                >
                  Select All
                </Checkbox>
              )}
            </div>
          )}
          <EditSelectTable
            columns={departmentcolumns}
            tabledata={departmentList}
            setOpenModal={() => setOpenDepartmentModal(true)}
            Name="Add Department"
          />
          <FormModal
            isModalVisible={openDepartmentModal}
            closeModal={() => setOpenDepartmentModal(false)}
            Name="Department"
          />
        </>
      ),
    },
    {
      id: 3,
      label: "Location",
      component: (
        <>
          {!viewOnly && (
            <div className="mb-3 d-flex justify-content-between">
              {filterLocationList?.length > 0 && (
                <Checkbox
                  className=""
                  checked={selectAllLocationChecked}
                  onChange={handleSelectAllLocationChange}
                >
                  Select All
                </Checkbox>
              )}
            </div>
          )}

          <EditSelectTable
            columns={locatincolumns}
            tabledata={filterLocationList}
            setOpenModal={() => setOpenLocationModal(true)}
            Name="Add Location"
          />
          <FormModal
            isModalVisible={openLocationModal}
            closeModal={() => setOpenLocationModal(false)}
            Name="Location"
          />
        </>
      ),
    },
  ];

  const handlePublish = async () => {
    await onFinish(true);
    closeModal(false);
  };

  return (
    <>
      {isModalVisible && (
        <>
          <label
            className="bg-transparent border-0 mb-3 text-left styled-cursor"
            onClick={() => {
              closeModal(false);
            }}
          >
            Leave
            <ArrowForwardIosIcon className="px-1" />
          </label>{" "}
          <b className=" pb-0 pt-1">{data.leaveCategoryName}</b>
          {!LeaveDetails?.publishedstatus && (
            <div className="text-end">
              <ButtonOutlined onClick={() => setPublishOpen(true)}>
                Publish Leave
              </ButtonOutlined>
            </div>
          )}
          <TabsList items={items} form={form} />
        </>
      )}

      <AlertModal
        isModalOpen={publishOpen}
        handleCancel={() => setPublishOpen(false)}
        handleOk={() => handlePublish()}
        name={"Are you sure you want to Publish the Leave?"}
        note={"Note: After Publishing you cannot able to edit the Leave"}
        loading={loading}
      />
      <Modal
        // title="Leave Settings"
        header={null}
        open={showPopup}
        onCancel={() => setShowPopup(false)}
        footer={null}
        centered
        maskClosable={false}
      >
        <div style={{ marginBottom: 16 }}>
          <label
            style={{
              fontWeight: 500,
              fontSize: 16,
              display: "block",
              marginBottom: 8,
            }}
          >
            <span style={{ color: "red", marginRight: 4 }}>*</span>
            Do you want to roll over this leave to next year?
          </label>

          <Radio.Group
            value={data?.rollout}
            onChange={(e) => {
              setData((prev) => ({
                ...prev,
                rollout: e.target.value,
                expiry_date: e.target.value === "No" ? null : prev.expiry_date,
              }));
              setShowPopup(false);
            }}
          >
            <Radio value={"Yes"}>Yes</Radio>
            <Radio value={"No"}>No</Radio>
          </Radio.Group>
        </div>
      </Modal>
    </>
  );
};
const mapStateToProps = (state) => ({
  ClientId: getClientid(state),
  locationList: getLocations(state),
  departmentList: getAllDepartmentList(state),
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setBreakTypes: setBreakTypesList,
      saveLeaveCategoryList: setLeaveCategoryList,
      saveRoleList: setRoleList,
    },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps, null)(EditLeaves);
